import { create } from "zustand";


export const useSlide = create((set) => ({
  slide: 0,
  setSlide: (slide) => set({ slide }),
}))
